(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bt-clean-category-description"] && !Shopify.designMode) return;
  try {
    (() => {
    const japanese = (document.documentElement.lang || 'ja').toLowerCase().startsWith('ja');
    const labels = japanese
      ? {
          material: '素材・カラー・付属品',
          specification: '商品仕様',
          specificationSizes: '対応サイズ・商品仕様',
          support: '配送・返品・ご購入前の注意事項',
          related: '関連情報',
          exceptions: '即納対象外のバリエーション'
        }
      : {
          material: 'Materials, colors and included items',
          specification: 'Product specifications',
          specificationSizes: 'Compatible sizes and product specifications',
          support: 'Delivery, returns and purchase information',
          related: 'Related information',
          exceptions: 'Variants requiring a backorder'
        };
    const materialLabels = new Set(['素材', 'カラー', '梱包について', '保護フィルム', 'ブランド', 'セット内容', '付属品']);
    const relatedLabels = new Set(['一緒におすすめ', '同じタイプの商品を探す']);
    const groupOrder = ['material', 'specification', 'support', 'related'];
    const observedSections = new WeakSet();

    const makeGroup = (key, label) => {
      const fold = document.createElement('details');
      fold.className = 'bt-category-fold';
      fold.dataset.btCategoryGroup = key;
      const summary = document.createElement('summary');
      summary.textContent = label;
      const content = document.createElement('div');
      content.className = 'bt-category-fold__content';
      fold.append(summary, content);
      return { fold, content };
    };

    const organizeRoot = root => {
      const area = root.querySelector('.bt-product-description-area');
      const list = area?.querySelector(':scope > .bt-product-accordion-list');
      if (!list) return;
      const groups = new Map();
      const getGroup = key => {
        if (groups.has(key)) return groups.get(key);
        const fold = list.querySelector(':scope > .bt-category-fold[data-bt-category-group="' + key + '"]');
        const group = fold
          ? { fold, content: fold.querySelector(':scope > .bt-category-fold__content') }
          : makeGroup(key, labels[key]);
        groups.set(key, group);
        return group;
      };

      const items = Array.from(list.children).filter(node => node.matches('details.bt-accordion'));
      items.forEach(node => {
        if (node.classList.contains('bt-accordion--outlet')) return;
        node.removeAttribute('open');
        if (node.hasAttribute('data-bt-variant-delivery-copy')) {
          getGroup('support').content.append(node);
          return;
        }
        const label = node.querySelector(':scope > summary')?.textContent.trim() || '';
        const key = materialLabels.has(label) ? 'material' : relatedLabels.has(label) ? 'related' : 'specification';
        const group = getGroup(key);
        if (key === 'specification' && label === 'サイズ') {
          group.fold.querySelector(':scope > summary').textContent = labels.specificationSizes;
        }
        group.content.append(node);
      });

      const common = root.querySelector('.bt-common-tabs');
      if (common) {
        const support = getGroup('support');
        if (common.parentElement !== support.content) {
          common.querySelectorAll('details[open]').forEach(node => node.removeAttribute('open'));
          support.content.append(common);
        }
      }

      const exceptions = area.querySelector(':scope > .bt-product-lead .bt-backorder-variant-list');
      if (exceptions) {
        const support = getGroup('support');
        let exceptionFold = support.content.querySelector(':scope > .bt-category-fold[data-bt-category-group="exceptions"]');
        if (!exceptionFold) {
          exceptionFold = makeGroup('exceptions', labels.exceptions).fold;
          support.content.prepend(exceptionFold);
        }
        exceptionFold.querySelector(':scope > .bt-category-fold__content').append(exceptions);
      }

      const sizeNav = root.querySelector('.cj-size-nav');
      if (sizeNav) {
        const specification = getGroup('specification');
        if (sizeNav.parentElement !== specification.content) specification.content.append(sizeNav);
        const summary = specification.fold.querySelector(':scope > summary');
        if (summary.textContent !== labels.specificationSizes) summary.textContent = labels.specificationSizes;
      }

      const tags = root.querySelector('.bt-product-tags');
      if (tags) {
        const related = getGroup('related');
        if (tags.parentElement !== related.content) related.content.append(tags);
      }

      const wanted = groupOrder.map(key => getGroup(key)).filter(group => group.content.childElementCount > 0);
      groups.forEach(group => {
        if (!group.content.childElementCount && group.fold.parentElement === list) group.fold.remove();
      });
      const current = Array.from(list.children).filter(node => node.matches('.bt-category-fold[data-bt-category-group]'));
      if (current.length !== wanted.length || wanted.some((group, index) => current[index] !== group.fold)) {
        wanted.forEach(group => list.append(group.fold));
      }
      const after = root.closest('.product-details')?.querySelector('.bt-product-after-buy');
      const offer = after?.querySelector('.bt-auto-cross-sell__section');
      const title = offer?.querySelector('.bt-auto-cross-sell__title')?.textContent.trim();
      const hasChoices = Boolean(offer?.querySelector('[data-bt-bundle-item]:not([hidden])'));
      let bundleFold = after?.closest('.bt-category-bundle');
      if (after && title && hasChoices && !bundleFold) {
        const bundle = makeGroup('bundle', title);
        bundle.fold.classList.add('bt-category-bundle');
        const lead = area.querySelector(':scope > .bt-product-lead');
        if (lead) lead.after(bundle.fold);
        else list.before(bundle.fold);
        bundle.content.append(after);
        bundleFold = bundle.fold;
      }
      if (bundleFold) {
        const hidden = !title || !hasChoices;
        if (bundleFold.hidden !== hidden) bundleFold.hidden = hidden;
      }

      root.classList.add('bt-clean-category-description');
      list.dataset.btCategoryOrganized = 'true';
    };

    const organizeSection = section => {
      if (!section.querySelector('[data-bt-clean-category-description]')) return;
      section.classList.add('bt-clean-category-product');
      document.documentElement.classList.add('bt-clean-category-recommendations');
      section.querySelectorAll('.bt-product-details').forEach(organizeRoot);
    };

    const start = () => {
      document.querySelectorAll('[data-bt-clean-category-description]').forEach(marker => {
        const section = document.getElementById('shopify-section-' + marker.dataset.btSectionId);
        if (!section || !section.contains(marker)) return;
        organizeSection(section);
        if (observedSections.has(section)) return;
        observedSections.add(section);
        let pending = false;
        const observer = new MutationObserver(() => {
          if (pending) return;
          pending = true;
          requestAnimationFrame(() => {
            pending = false;
            organizeSection(section);
          });
        });
        observer.observe(section, { childList: true, subtree: true });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bt-halloween-background-v1"] && !Shopify.designMode) return;
  try {
    (() => {
  const background = document.getElementById('BtHw26Background');
  const main = document.getElementById('MainContent');
  if (!background || !main || main.dataset.template.split('.')[0] !== 'index') return;
  const end = Number(background.dataset.ends);
  const root = document.documentElement;
  let timer;
  let surfaces = [];
  const remove = () => {
    clearTimeout(timer);
    root.classList.remove('bt-hw26-bg-on');
    surfaces.forEach(surface => surface.removeAttribute('data-bt-hw26-bg-surface'));
    background.remove();
    document.removeEventListener('visibilitychange', update);
    window.removeEventListener('pageshow', update);
  };
  function update() {
    clearTimeout(timer);
    const remaining = end - Date.now();
    if (remaining <= 0) { remove(); return; }
    background.toggleAttribute('data-paused', document.hidden);
    timer = setTimeout(update, Math.min(remaining, 60000));
  }
  if (Date.now() >= end) { background.remove(); return; }
  const candidates = main.querySelectorAll('.section-background, .bt-home-search, .bt-recently-viewed, .bt-home-banners, .bt-home-tabs, .bt-home-grid, .bt-home-info');
  surfaces = Array.from(candidates).filter(surface => {
    const color = getComputedStyle(surface).backgroundColor;
    return color === 'rgb(255, 255, 255)' || color === 'rgb(245, 245, 247)';
  });
  surfaces.forEach(surface => surface.setAttribute('data-bt-hw26-bg-surface', ''));
  root.classList.add('bt-hw26-bg-on');
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
